import React, {Component} from "react";
import Plot from "react-plotly.js";

class DecompositionGraph extends Component {

	render() {
		//TODO: Don't default to these when props is not set, show error message instead
		let dates = ["2015-04-15", "2015-04-16", "2015-04-17", "2015-04-18", "2015-04-19", "2015-04-20", "2015-04-21", "2015-04-22", "2015-04-23", "2015-04-24", "2015-04-25", "2015-04-26", "2015-04-27", "2015-04-28", "2015-04-29", "2015-04-30", "2015-05-01", "2015-05-02", "2015-05-03", "2015-05-04", "2015-05-05", "2015-05-06", "2015-05-07", "2015-05-08", "2015-05-09", "2015-05-10", "2015-05-11", "2015-05-12", "2015-05-13", "2015-05-14", "2015-05-15", "2015-05-16", "2015-05-17", "2015-05-18", "2015-05-19", "2015-05-20", "2015-05-21", "2015-05-22", "2015-05-23", "2015-05-24", "2015-05-25", "2015-05-26", "2015-05-27", "2015-05-28", "2015-05-29", "2015-05-30", "2015-05-31", "2015-06-01", "2015-06-02", "2015-06-03", "2015-06-04", "2015-06-05", "2015-06-06", "2015-06-07", "2015-06-08", "2015-06-09", "2015-06-10", "2015-06-11", "2015-06-12", "2015-06-13", "2015-06-14", "2015-06-15", "2015-06-16", "2015-06-17", "2015-06-18", "2015-06-19", "2015-06-20", "2015-06-21", "2015-06-22", "2015-06-23", "2015-06-24", "2015-06-25", "2015-06-26", "2015-06-27", "2015-06-28", "2015-06-29", "2015-06-30", "2015-07-01", "2015-07-02", "2015-07-03", "2015-07-04", "2015-07-05", "2015-07-06", "2015-07-07", "2015-07-08", "2015-07-09", "2015-07-10", "2015-07-11", "2015-07-12", "2015-07-13", "2015-07-14", "2015-07-15", "2015-07-16", "2015-07-17", "2015-07-18", "2015-07-19", "2015-07-20", "2015-07-21", "2015-07-22", "2015-07-23", "2015-07-24", "2015-07-25", "2015-07-26", "2015-07-27", "2015-07-28", "2015-07-29", "2015-07-30", "2015-07-31", "2015-08-01", "2015-08-02", "2015-08-03", "2015-08-04", "2015-08-05", "2015-08-06", "2015-08-07", "2015-08-08", "2015-08-09", "2015-08-10", "2015-08-11", "2015-08-12", "2015-08-13", "2015-08-14", "2015-08-15", "2015-08-16", "2015-08-17", "2015-08-18", "2015-08-19", "2015-08-20", "2015-08-21", "2015-08-22", "2015-08-23", "2015-08-24", "2015-08-25", "2015-08-26", "2015-08-27", "2015-08-28", "2015-08-29", "2015-08-30", "2015-08-31", "2015-09-01", "2015-09-02", "2015-09-03", "2015-09-04", "2015-09-05", "2015-09-06", "2015-09-07", "2015-09-08", "2015-09-09", "2015-09-10", "2015-09-11", "2015-09-12", "2015-09-13", "2015-09-14", "2015-09-15", "2015-09-16", "2015-09-17", "2015-09-18", "2015-09-19", "2015-09-20", "2015-09-21", "2015-09-22", "2015-09-23", "2015-09-24", "2015-09-25", "2015-09-26", "2015-09-27", "2015-09-28", "2015-09-29", "2015-09-30", "2015-10-01", "2015-10-02", "2015-10-03", "2015-10-04", "2015-10-05", "2015-10-06", "2015-10-07", "2015-10-08", "2015-10-09", "2015-10-10", "2015-10-11", "2015-10-12", "2015-10-13", "2015-10-14", "2015-10-15"];
		let percentWithTillageData = [100, 87.80826619, 81.1045835, 74.31687863, 69.92763336, 67.10289645, 64.56053371, 62.88906018, 61.3332288, 59.39859179, 56.93260032, 55.12076378, 53.10667181, 50.99933936, 48.5453765, 46.69500647, 44.6622539, 41.5253031, 37.80111508, 34.78043273, 31.72026003, 29.00421437, 26.35303586, 24.0780525, 22.3810939, 20.693206, 19.41448635, 18.53065305, 17.83962745, 16.94773344, 15.64603784, 14.45135206, 13.29441298, 12.45913128, 12.01862417, 11.71011123, 11.22112738, 10.64658765, 9.997326267, 9.335869403, 8.729201577, 8.24140403, 7.80585557, 7.41024397, 7.005903068, 6.7702715, 6.617858492, 6.425008424, 6.22031988, 6.000653159, 5.766745164, 5.566063058, 5.400441011, 5.211958835, 5.053821545, 4.914539511, 4.764679984, 4.64054197, 4.537521996, 4.445558063, 4.358974381, 4.283246082, 4.224163606, 4.17786005, 4.126038064, 4.088148922, 4.047505397, 4.009098735, 3.973140185, 3.943999263, 3.921497069, 3.897398158, 3.879170471, 3.863158719, 3.848769084, 3.833440346, 3.81989032, 3.808654034, 3.799034128, 3.789396926, 3.781134294, 3.772893684, 3.764567493, 3.75853423, 3.754371429, 3.749172446, 3.744250497, 3.739954624, 3.735039548, 3.730251173, 3.726453195, 3.723685244, 3.720910175, 3.717796512, 3.715050784, 3.712878533, 3.711070875, 3.709620673, 3.70836136, 3.707109636, 3.705985777, 3.704848799, 3.703844562, 3.70295404, 3.702149903, 3.701509092, 3.70095616, 3.700453513, 3.700026627, 3.69958733, 3.699244769, 3.698963459, 3.698684187, 3.698415961, 3.69819023, 3.697968915, 3.697768704, 3.697586087, 3.697435068, 3.697310784, 3.697194447, 3.697081782, 3.696975317, 3.696876942, 3.696790217, 3.696717241, 3.69666191, 3.696615153, 3.696568531, 3.696528122, 3.696491071, 3.696461371, 3.696433815, 3.696410378, 3.696388218, 3.696363434, 3.696338146, 3.696313456, 3.696291545, 3.696269991, 3.696250479, 3.696233495, 3.696218371, 3.696205608, 3.696193753, 3.696182968, 3.696174047, 3.6961674, 3.69616181, 3.69615769, 3.696154606, 3.696151669, 3.696147736, 3.696143716, 3.696140233, 3.696136656, 3.696133478, 3.696131562, 3.696129928, 3.696128235, 3.696126435, 3.696124697, 3.696123184, 3.696121822, 3.696120571, 3.696119312, 3.696118139, 3.696117263, 3.696116685, 3.696116242, 3.696115754, 3.696115334, 3.696114875, 3.696114361, 3.69611386, 3.696113375, 3.696112908, 3.696112564, 3.696112319, 3.696111938, 3.696111558, 3.696111313, 3.696111134, 3.696110924];
		let percentWoTillageData = [100, 95.25244773, 92.45766945, 89.47016594, 87.44215498, 86.09249857, 84.84545399, 84.00786446, 83.21492119, 82.21014851, 80.89747645, 79.90875892, 78.78393806, 77.57613099, 76.12676189, 75.00098795, 73.72900772, 71.68673011, 69.12054131, 66.90807598, 64.52594597, 62.27230856, 59.92253387, 57.7659163, 56.05781338, 54.26037491, 52.82341769, 51.78724412, 50.95008222, 49.83112316, 48.11069441, 46.42599964, 44.67977604, 43.33602545, 42.59512778, 42.06161281, 41.18922033, 40.11794558, 38.83890755, 37.44862505, 36.08138747, 34.90577072, 33.78788693, 32.70680166, 31.52516779, 30.79471571, 30.30353553, 29.65866655, 28.94244819, 28.13246977, 27.21537327, 26.3757697, 25.63962326, 24.74560454, 23.94060405, 23.18182355, 22.3025713, 21.51422863, 20.80955278, 20.1336755, 19.44846624, 18.80197195, 18.26061999, 17.80943326, 17.2712776, 16.85174589, 16.3726888, 15.88723553, 15.39792484, 14.97157155, 14.62052695, 14.2195141, 13.89592078, 13.59471791, 13.30832413, 12.98414251, 12.67829456, 12.40848611, 12.16386076, 11.9041073, 11.66778312, 11.41741787, 11.14687131, 10.93777897, 10.78608223, 10.58685103, 10.38672905, 10.20139684, 9.974941639, 9.736532694, 9.532200062, 9.373046253, 9.203182966, 8.997885219, 8.801047983, 8.632357384, 8.48130443, 8.351703571, 8.231956625, 8.105095207, 7.983310241, 7.850997345, 7.724920925, 7.604309747, 7.486711418, 7.385829098, 7.29262134, 7.201972729, 7.119723739, 7.029046293, 6.953269026, 6.887099091, 6.817272463, 6.745629226, 6.68121412, 6.613698214, 6.548178179, 6.483987577, 6.42707241, 6.377134509, 6.327395764, 6.275966415, 6.223850402, 6.172033346, 6.122818714, 6.078301349, 6.042288508, 6.010072079, 5.976056494, 5.944799458, 5.914454359, 5.888787423, 5.863745774, 5.841391914, 5.819243796, 5.793145756, 5.764842433, 5.735281051, 5.70714011, 5.677343219, 5.648167817, 5.620682694, 5.5941923, 5.570029114, 5.545761335, 5.521806704, 5.500323738, 5.483118546, 5.467704527, 5.455700648, 5.446304143, 5.436993914, 5.4238979, 5.409658383, 5.396500603, 5.382041821, 5.368235532, 5.359390807, 5.351491973, 5.342923746, 5.333309419, 5.32347056, 5.314382021, 5.305720953, 5.297291838, 5.288278711, 5.279310547, 5.272198941, 5.267291593, 5.263385251, 5.258936633, 5.254976014, 5.250487448, 5.245241899, 5.239880205, 5.234437117, 5.228899171, 5.224626807, 5.221472316, 5.216335749, 5.210925316, 5.207272401, 5.204493166, 5.201125595];
		let rateWithTillageData = [null, null, null, 65.79421, 46.49546, 36.43105, 25.9673, 21.05808, 20.34059, 18.87954, 19.56478, 20.66778, 21.70643, 20.47519, 20.91702, 23.16274, 26.39645, 27.52989, 29.94949, 31.31608, 30.34453, 27.44613, 24.79868, 22.05411, 19.17946, 15.64477, 12.47685, 10.86672, 10.09434, 9.92627, 10.47248, 10.76099, 9.85822, 7.87185, 6.46045, 5.29565, 4.92361, 5.36551, 5.96182, 5.95945, 5.68146, 5.17416, 4.65993, 3.91786, 3.24709, 2.76169, 2.37985, 2.0105, 2.00705, 2.10359, 2.04913, 2.01672, 1.89366, 1.70441, 1.60277, 1.5198, 1.34887, 1.21653, 1.11113, 0.96287, 0.83276, 0.71932, 0.63904, 0.54165, 0.47148, 0.43013, 0.40944, 0.36408, 0.3333, 0.30021, 0.25986, 0.21996, 0.19046, 0.17611, 0.15502, 0.14103, 0.12825, 0.11874, 0.10461, 0.09399, 0.08817, 0.081, 0.07005, 0.06392, 0.05729, 0.04923, 0.04699, 0.04824, 0.04544, 0.04113, 0.03809, 0.03449, 0.0304, 0.02715, 0.02523, 0.02258, 0.01887, 0.01588, 0.01379, 0.01244, 0.01155, 0.01081, 0.00992, 0.00895, 0.00779, 0.00678, 0.00585, 0.00513, 0.00453, 0.00399, 0.00354, 0.00322, 0.00279, 0.00255, 0.00239, 0.0022, 0.00196, 0.00176, 0.00155, 0.00137, 0.00122, 0.00112, 0.00104, 0.00095, 0.00084, 0.00072, 0.00062, 0.00052, 0.00045, 0.0004, 0.00036, 0.00032, 0.00028, 0.00026, 0.00025, 0.00024, 0.00024, 0.00024, 0.00023, 0.00021, 0.00019, 0.00017, 0.00015, 0.00014, 0.00012, 0.0001, 0.00009, 0.00007, 0.00006, 0.00004, 0.00004, 0.00004, 0.00003, 0.00004, 0.00004, 0.00003, 0.00003, 0.00002, 0.00002, 0.00002, 0.00002, 0.00002, 0.00002, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0.00001, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
		let rateWoTillageData = [null, null, null, 27.815, 20.81399, 16.89961, 12.51049, 10.46401, 10.39004, 9.87339, 10.44785, 11.27758, 12.16677, 11.79298, 12.3595, 14.19442, 16.91118, 18.43737, 20.95008, 22.9134, 23.52839, 22.70925, 21.70053, 20.53114, 18.89778, 16.27058, 13.63167, 12.45338, 12.29936, 12.79484, 14.21494, 15.22811, 14.47199, 12.09816, 10.47356, 9.12366, 8.99424, 10.29301, 11.96045, 12.5669, 12.66012, 12.26421, 11.84691, 10.57334, 9.20447, 8.25844, 7.52871, 6.7854, 7.15868, 7.85553, 8.03809, 8.39369, 8.38373, 8.0671, 8.1464, 8.25079, 7.8721, 7.61386, 7.46671, 7.0012, 6.50722, 6.00024, 5.7248, 5.19344, 4.85857, 4.74677, 4.82302, 4.59941, 4.46244, 4.30635, 3.98263, 3.60641, 3.32649, 3.27277, 3.08244, 2.97487, 2.86171, 2.80843, 2.63272, 2.52175, 2.52323, 2.45216, 2.23605, 2.16186, 2.06138, 1.89095, 1.92567, 2.0991, 2.1093, 2.02737, 1.99643, 1.95411, 1.87097, 1.79969, 1.78348, 1.70296, 1.53186, 1.39191, 1.29809, 1.26061, 1.25357, 1.25529, 1.23677, 1.19496, 1.11675, 1.0459, 0.96917, 0.91533, 0.86512, 0.81104, 0.7694, 0.74819, 0.69566, 0.67914, 0.67784, 0.66657, 0.63711, 0.60816, 0.5726, 0.54442, 0.52027, 0.51008, 0.50863, 0.49819, 0.46736, 0.42756, 0.39195, 0.35604, 0.32769, 0.307, 0.29265, 0.26933, 0.25111, 0.24262, 0.24789, 0.25693, 0.2685, 0.2838, 0.28996, 0.28832, 0.28218, 0.27422, 0.26316, 0.25272, 0.24072, 0.22215, 0.20465, 0.18012, 0.15101, 0.12666, 0.11844, 0.11609, 0.1184, 0.12852, 0.13752, 0.12901, 0.11633, 0.10715, 0.09746, 0.08953, 0.09002, 0.09154, 0.09126, 0.09006, 0.08832, 0.08437, 0.07686, 0.06781, 0.05868, 0.04867, 0.04342, 0.0441, 0.04701, 0.049, 0.05215, 0.05172, 0.04754, 0.04709, 0.04702, 0.04325, 0.04027, 0.04069, 0.03803, 0.03267];

		let title = "Error Getting Decomposition - Showing Placeholder Graph";
		let graphInfo = {};
		if (this.props["graphInfo"]){
			graphInfo = this.props["graphInfo"];
			dates = graphInfo.dates;
			percentWithTillageData = graphInfo.percentWithTillageData;
			percentWoTillageData = graphInfo.percentWoTillageData;
			rateWithTillageData = graphInfo.rateWithTillageData;
			rateWoTillageData = graphInfo.rateWoTillageData;
			title = "Decomposition after Termination";
		}

		let startDate = dates[0];
		let breakDate = dates[21]; // TODO: need to define this logic for transition to gradual decomposition
		let endDate = dates[dates.length - 1];

		let percentWithTillage = {
			x: dates,
			y: percentWithTillageData,
			name: "Percent w/ Tillage",
			type: "scatter",
			mode: "lines",
			connectgaps: false,
			line: {color: "MediumOrchid"},
			hoverlabel: {namelength: 25}
		};

		let percentWoTillage = {
			x: dates,
			y: percentWoTillageData,
			name: "Percent w/o Tillage",
			// yaxis: "y2",
			type: "scatter",
			mode: "lines", //lines+marks
			connectgaps: false,
			line: {color: "MediumOrchid", dash: "dot"},
			hoverlabel: {namelength: 25}
		};

		let rateWithTillage = {
			x: dates,
			y: rateWithTillageData,
			yaxis: "y2",
			name: "Rate w/ Tillage",
			type: "scatter",
			mode: "lines",
			connectgaps: false,
			line: {color: "Teal"},
			hoverlabel: {namelength: 25}
		};

		let rateWoTillage = {
			x: dates,
			y: rateWoTillageData,
			name: "Rate w/o Tillage",
			yaxis: "y2",
			type: "scatter",
			mode: "lines", //lines+marks
			connectgaps: false,
			line: {color: "Teal", dash: "dot"},
			hoverlabel: {namelength: 25}
		};

		let data = [percentWithTillage, percentWoTillage, rateWithTillage, rateWoTillage];

		let highlightShapes = [
			{
				type: "rect",
				xref: "x",
				yref: "paper",
				x0: startDate,
				y0: 0,
				x1: breakDate,
				y1: 1,
				fillcolor: "rgb(240, 220, 220)",
				opacity: 0.3,
				layer: "below",
				line: {width: 0.1}
			},
			{
				type: "rect",
				xref: "x",
				yref: "paper",
				x0: breakDate,
				y0: 0,
				x1: endDate,
				y1: 1,
				fillcolor: "rgb(240, 240, 194)",
				opacity: 0.3,
				layer: "below",
				line: {width: 0.1}
			},
		];

		let annotations = [
			{
				x: 0.02,
				y: 1.08,
				xref: "paper",
				yref: "paper",
				text: "Rapid Decomposition Period",
				borderpad: 4,
				bgcolor: "#FAF4F4",
				showarrow: false,
				font: {
					size: 12,
					color: "Black"
				},
				opacity: 0.8,
				xshift: -20
			},
			{
				x: 0.6,
				y: 1.08,
				xref: "paper",
				yref: "paper",
				text: "Gradual Decomposition Period",
				borderpad: 4,
				bgcolor: "#F6F2E4",
				showarrow: false,
				font: {
					size: 12,
					color: "Black"
				},
				opacity: 0.8,
				xshift: -20
			}
		];

		let layout = {
			title: title,
			width: 930,
			height: 600,
			// responsive: true,
			xaxis: {
				range: [startDate, endDate],
				showline: true,
				linecolor: "LightGray",
				zeroline: true,
				ticks: "outside"
			},
			yaxis: {
				title: {
					text: "Percent Biomass Remaining",
					font: {
						color: "MediumOrchid"
					}
				},
				tickfont: {color: "MediumOrchid"},
				showgrid: false,
				showline: true,
				linecolor: "LightGray",
				ticks: "outside",
				range: [0, 100],
				rangemode: "tozero"
			},
			yaxis2: {
				title: {
					text: "Decomposition Rate (lb/acre/day)",
					font: {
						color: "Teal"
					}
				},
				tickfont: {color: "Teal"},
				overlaying: "y",
				side: "right",
				showgrid: false,
				showline: true,
				linecolor: "LightGray",
				ticks: "outside"
			},
			shapes: highlightShapes,
			annotations: annotations,
			legend: {x: 0.88, y: 1.40, borderwidth: 0.5}
		};

		return (
			<div >
				<Plot
							data={data}
							layout={layout}
							config={{
								"displayModeBar": false
							}}
				/>
			</div>
		);
	}
}

export default DecompositionGraph;
